var map = {
	"./en/1-10/1_10_tit.png": 18561,
	"./fi/1-10/1_10_tit.png": 78159,
	"./in/1-10/1_10_tit.png": 85741,
	"./th/1-10/1_10_tit.png": 81236,
	"./tw/1-10/1_10_tit.png": 76611,
	"./zh/1-10/1_10_tit.png": 66418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61057;